// The end-of-trip endpoints for this panel (Booking Flow v2). The trip modals are the same file in the
// admin and staff panels; only this map differs.
const tripUrls = {
    close: (bookingId) => `/admin/booking/trip/close/${bookingId}`,
    completePreview: (bookingId) => `/admin/booking/trip/complete/preview/${bookingId}`,
    complete: (bookingId) => `/admin/booking/trip/complete/${bookingId}`,
    endTime: (bookingId) => `/admin/booking/trip/end-time/${bookingId}`,
    damage: (bookingId) => `/admin/booking/damage/${bookingId}`,
    finesPreview: (bookingId) => `/admin/booking/inspect/preview/${bookingId}`,
    fines: (bookingId) => `/admin/booking/inspect/${bookingId}`,
    swap: (bookingId) => `/admin/booking/trip/swap/${bookingId}`,
    availableCars: "/admin/booking/available-cars",
    pendingVerify: (bookingId) => `/admin/booking/pending/verify/${bookingId}`,
};

export default tripUrls;
